import React from 'react';
import styled from 'styled-components';
import {useOutlet} from 'reconnect.js';
import {withLoginRequired} from 'rev.sdk.js/Components/LoginRequired';
import {Result, Space, Button} from 'antd';
import {getOutlet} from 'reconnect.js';
import qs from 'query-string';
import SiteNavBar from '../../Components/SiteNavBar';
import ProfileMenu, {ProfileTabs} from '../ProfileTabs';
import * as AppActions from '../..//AppActions';

function ProfileLayout(props) {
  const {style = {}} = props;
  const [dimension] = useOutlet('dimension');
  const activePath = props.location.pathname.split('/')[2];
  const mobile = dimension.rwd === 'mobile';
  const params = qs.parse(props.location.search);

  const _renderCustomSection = React.useCallback(
    (sectionId) => {
      if (renderCustomSection && typeof renderCustomSection === 'function') {
        return renderCustomSection({
          route: props.location.pathname,
          sectionId,
          params,
        });
      }
      // customRenderFunc backward compatibility
      if (AppActions.renderCustomSection) {
        return AppActions.renderCustomSection({
          route: props.location.pathname,
          sectionId,
          params,
        });
      }

      return null;
    },
    [params, props.location.pathname, renderCustomSection],
  );

  function renderCustomSection(sectionId) {
    return null;
  }

  return (
    <Wrapper style={{...style}}>
      <div className="content">
        <div
          style={{display: 'flex', flexDirection: mobile ? 'column' : 'row'}}>
          {mobile ? (
            <ProfileTabs activePath={activePath} />
          ) : (
            <div style={{display: 'flex', flexDirection: 'column'}}>
              <ProfileMenu activePath={activePath} />
            </div>
          )}

          <div style={{display: 'flex', flexDirection: 'column', flex: 1}}>
            <div style={{padding: 'var(--basePadding)'}}>{props.children}</div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: var(--topNavBarHeight);

  & > .content {
    max-width: var(--contentMaxWidth);
    min-height: var(--contentMinHeight);
    margin: 0 auto;
    padding: var(--basePadding);
  }
`;

export default withLoginRequired(ProfileLayout, {
  admin: false,
  SiteNavBar,
  renderLoginRequired: (options) => {
    const loginModal = getOutlet('login-modal');
    return (
      <div
        style={{
          minHeight: 'var(--contentMinHeight)',
          paddingTop: 'var(--topNavBarHeight)',
        }}>
        <Result
          title="尚無權限"
          subTitle="此頁面需要登入，方能瀏覽"
          extra={
            <Space direction="vertical">
              <Button
                onClick={() => {
                  loginModal.update(true);
                }}>
                登入
              </Button>
            </Space>
          }
        />
      </div>
    );
  },
});
